import useForm from '../../../../customHooks/useForm';
import ProfileLabelAndTitle from '../../../../components/ProfileLabelAndTitle';

interface IInstitutionInfoDetails{
  payload:any;
}
const InstitutionInfoDetails = ({
  payload,
}:IInstitutionInfoDetails) => {
  const {
    formValues,
  } = useForm(
    {
      institution_name: payload?.institution_name,
      campus: payload?.campus || '*******',
      degree: payload?.degree,
      flight_question: payload?.flight_question || '*******',
      flight_answer: payload?.flight_answer || '*******',
      isPGWPEligible: payload?.isPGWPEligible ? 'Yes' : 'No',
      institution_city: payload?.institution_city || '',
      institution_province: payload?.institution_province || '',
      otherProgramme: '',
      student: payload?.enrollment_type === 'student' ? 'Yes' : 'No',
      nationality: payload?.nationality || '*******',
    },
  );

  return (
    <div>
      <div className="profile-detail-cover">
        <ProfileLabelAndTitle
          content={formValues}
          attribute={[
            'institution_name',
            'nationality',
            'student',
            'institution_city',
            'campus',
            'isPGWPEligible',
            'flight_question',
            'flight_answer',
          ]}
          label={{
            institution_name: 'Institution',
            nationality: 'Nationality',
            student: 'Student',
            institution_city: 'City',
            campus: 'Campus',
            isPGWPEligible: 'PGWP Eligible',
            flight_question: 'Flight Question',
            flight_answer: 'Flight Answer',
          }}
        />
      </div>
    </div>
  );
};
export default InstitutionInfoDetails;
